import { attribute } from 'dom-helpers';
import React, { Component } from 'react';
import { TransFn } from 'core/redux/features/languages/trans';
import { RouteComponentProps } from 'react-router';
import { ISteps } from 'core/redux/features/booking/types';
import { BOOKING_STEP1 } from '../../core/redux/features/booking/constants';
import { IProduct } from '../../core/redux/features/products/types';
import { Columns } from '../Elements';
import PropUpPage from '../PopUpPage';
import { LoadingType } from '../../core';

interface IMapToStateProps {
  steps: ISteps;
  trans: TransFn;
  loading: LoadingType;
  activeStepIndex: number;
  deviceType: string;
  product?: IProduct | null;
}

interface IMapToDispatchProps {
  onSubmitFormStep: (step: number, inputs: Record<string, any>) => void;
  setActiveStepIndex: (step: number) => void;
}

type RouteTypes = RouteComponentProps<{ step: string }>;

interface OwnProps {
  id?: string;
  children: React.ReactNode;
  enableNextBtn?: boolean;
  nextButtonLabel?: string;
  hideButtons?: boolean;
  onSubmit?: (e: React.SyntheticEvent) => void;
  // formInputValues: Record<string, any>,
  onGetFormInputs?: () => Record<string, any>;
  className: string;
}

type IProps = OwnProps & IMapToStateProps & IMapToDispatchProps & RouteTypes;

export default class StepFormCreator extends Component<IProps> {
  static defaultProps = {
    enableNextBtn: true,
    hideButtons: false,
    id: '',
    className: '',
  };

  componentDidMount(): void {
    const { match, steps, setActiveStepIndex, activeStepIndex } = this.props;

    const findStep = Object.values(steps).find(
      item => item.route === match.params.step,
    );
    if (findStep && findStep.id !== activeStepIndex) {
      setActiveStepIndex(0);
    }
  }

  render() {
    const {
      children,
      trans,
      loading,
      enableNextBtn,
      nextButtonLabel,
      hideButtons,
      id,
      className,
    } = this.props;

    return (
      <PropUpPage
        className={`checkout ${className}`}
        autoDisableScroll={true}
        whiteBackdrop={true}
        // footer={
        //   <button
        //     style={{ display: deviceType === 'mobile' ? '' : 'none' }}
        //     className="button checkout__button button is-red-dark is-huge has-icon is-uppercase booking-button"
        //     type="submit"
        //     disabled={loading || !enableNextBtn}
        //     value="next"
        //     onClick={this.onNext}
        //   >
        //     {trans('next')}
        //     <span className="eb eb-pr icon is-right" />
        //   </button>
        // }
      >
        <form onKeyDown={this.onKeyDown} onSubmit={this.onNext} id={id}>
          <div className="container">
            <Columns className="checkout__content">{children}</Columns>
          </div>
          {!hideButtons ? (
            <div className="container">
              <div className="checkout__footer">
                <div className="buttons is-flex-mid-left">
                  <button
                    className="button checkout__button is-outlined button--cancel"
                    value="cancel"
                    onClick={this.onCancel}
                  >
                    {trans('back')}
                  </button>
                  <button
                    // style={{ opacity: deviceType === 'mobile' ? 0 : 1 }}
                    className="button checkout__button button is-red-dark has-icon is-uppercase booking-button"
                    type="submit"
                    disabled={loading || !enableNextBtn}
                    value="next"
                    onClick={this.onNext}
                  >
                    {nextButtonLabel ?? trans('next')}
                    <span className="eb eb-pr icon is-right" />
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </form>
      </PropUpPage>
    );
  }

  private onNext = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const {
      props: { activeStepIndex, onSubmitFormStep, onGetFormInputs },
    } = this;

    const fieldValues = onGetFormInputs ? onGetFormInputs() : {};
    onSubmitFormStep(activeStepIndex, fieldValues);
  };

  private onKeyDown = (e: React.KeyboardEvent) => {
    if (
      (e.key === 'Enter' || e.keyCode === 13) &&
      Number(attribute(e.target as Element, 'data-key-handled')) !== 1
    ) {
      this.onNext(e);
    }
  };

  private onCancel = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const {
      props: { setActiveStepIndex, activeStepIndex, product },
    } = this;

    if (activeStepIndex === BOOKING_STEP1) {
      if (!product) {
        window.location.href = `/${product.product_type}/${product.slug}`;
      } else {
        window.location.href = '/';
      }
      return;
    }

    let prevIndex = activeStepIndex > 0 ? activeStepIndex - 1 : 0;

    if (prevIndex !== activeStepIndex) {
      setActiveStepIndex(prevIndex);
    }
  };
}
